/*************************************
 *
 * 预约路由管理
 *
 *************************************/

const appointment = [
  {
    path: '/appointment/index',
    name: 'Index',
    component: () => import('@/views/appointment/appointmentGoods/index'),
    meta: {
      title: '预约抢购',
      keepAlive: false,
      auth: false,
      isWechat: false
    }
  },
  {
    path: '/appointment/order',
    name: 'appointmentOrder',
    component: () => import('@/views/appointment/appointmentOrders/index'),
    meta: {
      title: '我的预约',
      keepAlive: true,
      auth: false,
      isWechat: false
    }
  }
]

export default appointment



// WEBPACK FOOTER //
// ./src/router/modules/appointment.js